// Кеш профілю користувача (ПІБ, аватар, номер картки). PasswordScreen і
// прелоад в App вже отримують users/{chatId} до входу — зберігаємо результат,
// щоб MainPage на першому ж кадрі малювала справжню картку, а не дефолтну,
// яка за мить підміняється (і разом з ім'ям власника зсуває верстку).
// Пам'ять — основне джерело в межах сесії, localStorage — між запусками.
const memory = new Map();

const keys = (chatId) => ({
  pib: `user_pib_${chatId}`,
  photo: `user_photo_${chatId}`,
  card: `user_card_${chatId}`,
});

export function readCachedUser(chatId) {
  if (memory.has(chatId)) return memory.get(chatId);
  const k = keys(chatId);
  try {
    return {
      pib: localStorage.getItem(k.pib) || '',
      photoUrl: localStorage.getItem(k.photo) || '',
      cardNumber: localStorage.getItem(k.card) || '',
    };
  } catch (e) {
    return { pib: '', photoUrl: '', cardNumber: '' };
  }
}

// Аватар — великий base64; якщо localStorage переповнений, звільняємо місце
// від старого кешу картинок (img_cache_*) і пробуємо ще раз.
function setItemWithRetry(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    if (!value) return;
    try {
      Object.keys(localStorage)
        .filter((k) => k.startsWith('img_cache_'))
        .forEach((k) => localStorage.removeItem(k));
      localStorage.setItem(key, value);
    } catch (e2) { /* ignore */ }
  }
}

export function cacheUser(chatId, user) {
  const next = {
    pib: user?.pib || '',
    photoUrl: user?.photoUrl || '',
    cardNumber: user?.cardNumber || '',
  };
  const prev = readCachedUser(chatId);
  memory.set(chatId, next);
  const k = keys(chatId);
  if (prev.pib !== next.pib) setItemWithRetry(k.pib, next.pib);
  if (prev.photoUrl !== next.photoUrl) setItemWithRetry(k.photo, next.photoUrl);
  if (prev.cardNumber !== next.cardNumber) setItemWithRetry(k.card, next.cardNumber);
  return next;
}
